import { Component, EventEmitter, Input, Output } from '@angular/core';
import { capitalizeFirstCharacter } from 'app/utilities/functions/capitalizeFirstCharacter';
import { CustomNotification } from 'app/utilities/types/notification';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css'],
  imports: [NgClass],
})
export class NotificationComponent {
  @Input() notification!: CustomNotification;
  @Output() onClose = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {}

  onCloseClick() {
    this.onClose.emit(this.notification.id);
  }

  cap = capitalizeFirstCharacter;
}
